import Mustache from 'mustache';

/**
 * Imports all ad templates (mustache files) from the ../templates/ads folder
 *
 * @return {Object} an object of key = name of mustache file minus `.mustache.html`
 *                               value = String of file contents
 */
const importAllAdTemplates = () => {
  const importAll = (require) => (
    require.keys().reduce((acc, next) => {
      const path = next.replace('./', '');
      // Disable no dynamic require so we can add ad templates and not
      // explicitly require each. This should not affect code analysis/linting
      // as the contents are HTML that are read as strings
      // eslint-disable-next-line import/no-dynamic-require
      acc[path.replace('.mustache.html', '')] = require(next).default;
      return acc;
    }, {})
  );

  return importAll(require.context('../templates/ads', false, /\.mustache.html/));
};

const templates = importAllAdTemplates();

window.adTemplates = templates;
window.Mustache = Mustache;
